import {Inject, Injectable, Injector, PLATFORM_ID} from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse, HttpHeaders, HttpResponse
} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError, map, retry, tap} from 'rxjs/operators';
import {UserService} from '../user/user.service';
import * as _ from 'lodash';
import {isPlatformBrowser, isPlatformServer} from '@angular/common';
import {makeStateKey, StateKey, TransferState} from '@angular/platform-browser';
import {User} from '@slarys/ufe-models';


@Injectable()
export class BrowserStateInterceptor  implements HttpInterceptor {

    constructor(@Inject(PLATFORM_ID) private platformId: any,
                private transferState: TransferState,
                public userService: UserService) {}

    handleError(error: HttpErrorResponse) {
        let errorMessage: string;

        if (error.status === 401 && !_.isNil(this.userService.loggedInUser.id)) {
            this.userService.logout().subscribe(response => {
                this.userService.loggedInUser = new User(null);
            });
        }

        if (error.error) {
            if (_.includes(error.error.message, 'P-A110' )) {
                location.reload();
            }
            errorMessage = `${error.error.message}`;
        }

        return throwError(errorMessage);
    }

    // intercept request and add token
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let token = null;
        console.log(this.platformId);
        if (isPlatformBrowser(this.platformId)) {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('token')) {
                localStorage.setItem('token', urlParams.get('token'));
            }
            token = localStorage.getItem('token');
        }

        request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${token}`), withCredentials: true });

        if (request.method !== 'GET') {
            return next.handle(request).pipe(
                catchError((error: HttpErrorResponse) => {
                    return this.handleError(error);
                })
            );
        }

        const key: StateKey<string> = makeStateKey<string>(request.url);

        if (isPlatformServer(this.platformId)) {
            return next.handle(request).pipe(tap((event) => {
                this.transferState.set(key, (event as HttpResponse<any>).body);
            }));
        } else {
            const storedResponse = this.transferState.get<any>(key, null);
            if (storedResponse) {
                const response = new HttpResponse({body: storedResponse, status: 200});
                this.transferState.remove(key);
                return of(response);
            } else {
                return next.handle(request).pipe();
            }
        }
    }
}
